/* eslint-disable */
import React, {useState, useCallback} from 'react';
import {NavLink, useLocation} from 'react-router-dom';
import PopBookmark from './_PopBookmark';
import PopSearch from  './_PopSearch';
import Logo from 'contents/assets/img/logo.png';
import LogoWhite from 'contents/assets/img/logo_white.png';
import IconCall from 'contents/assets/img/icon_call.png';
import IconChat from 'contents/assets/img/icon_chat.png';
import IconMail from 'contents/assets/img/icon_mail.png';
import IconMypage from 'contents/assets/img/icon_mypage.png';
import IconSearch from 'contents/assets/img/icon_search_white.png';
import IconLogout from 'contents/assets/img/icon_logout.png';

function Header() {
  const pathName = useLocation().pathname;
  const [isActive, setIsActive] = useState(false);
  const [isGnbActive, setIsGnbActive] = useState(false);
  const [searchActive, setSearchActive] = useState(false);
  const [gnbIdx, setGnbIdx] = useState(0);
  const [modalBookmark, setModalBookmark] = useState(false);
  const [modalSearch, setModalSearch] = useState(false);
  //상단 Gnb
  const gnbData = [
    {title: '학생관리', link: '/Html/Student/ClassStatistics'},
    {title: '교사관리', link: '/Html/Teacher/List'},
    {title: '교재관리', link: '/Html/Books/Notice'},
    {title: '자료실', link: '/Html/Data/'},
    {title: '커뮤니티', link: '/Html/Community/Index'},
    {title: '교사교육', link: '/Html/Training/EvaluationInterview'},
    {title: '홍보', link: '/Html/Promotion/PRClass'},
    {title: '회계관리', link: '/Html/Accounting/Month'},
    {title: '업무관리', link: '/Html/Manage/Employee'},
    {title: '통계', link: '/Html/Statistics/Index'}
    //{title: '마이', link: '/Html/Mypage/Teacher'}
  ];
  const listItems = ['수학 ㅣ 김교사102', '수학 ㅣ 김교사102', '수학 ㅣ 김교사102', '수학 ㅣ 김교사102', '수학 ㅣ 김교사102', '과탐 ㅣ 최교사456', '과탐 ㅣ 최교사456'];

  const [selectedItem, setSelectedItem] = useState(null);
  const renderGnb = useCallback(() => {
    return gnbData.map((v, idx) => {
      return (
        <NavLink
          to={v.link}
          key={idx}
          onClick={() => {
            setIsGnbActive(false);
            setGnbIdx(idx + 1);
          }}
          className={`link ${isGnbActive || gnbIdx === idx + 1 ? 'active' : ''}`}
        >
          {v.title}
        </NavLink>
      );
    });
  }, [gnbIdx]);
  //Left Sub Gnb Array
  const gnbSubMain = [
    {title: '캠페인/시상/인사', link: '/Html/Award', idx: 1},
    {title: '이달의 우수교사', link: '/Html/MonthlyBestTeacher', idx: 2},
    {title: '이지 직원 소개', link: '/Html/IntroduceMember', idx: 3},
    // {title: '특별회원 리스트', link: '/Html/SpeacialMember', idx: 4},
    {title: '새로 오신 이지가족', link: '/Html/NewMember', idx: 5}
  ];
  const gnbSubStudent = [
    {title: '교무통계', link: '/Html/Student/ClassStatistics', idx: 1},
    {title: '시범강의 보고서', link: '/Html/Student/PRClassReport', idx: 2},
    {title: '수업등록 요청', link: '/Html/Student/ClassRegister', idx: 3},
    {title: '배정 보고서', link: '/Html/Student/Assignment', idx: 4},
    {title: '학생목록', link: '/Html/Student/StudentList', idx: 5},
    {title: '학생 한줄 보고서', link: '/Html/Student/ShortReport', idx: 6},
    {title: '교무핫라인', link: '/Html/Student/HotLine', idx: 6},
    {title: '첫 수업  & 모니터링 보고서', link: '/Html/Student/FirstClassReport', idx: 7},
    {title: '취/중/인/종료 보고서', link: '/Html/Student/FinishReport', idx: 8},
    {title: '환불 보고서', link: '/Html/Student/Refund', idx: 9},
    {title: '타임변경/보류/재개', link: '/Html/Student/TimeChange', idx: 10},
    {title: '출석부', link: '/Html/Student/Attendance', idx: 11},
    {title: '면접일정 관리', link: '/Html/Student/InterviewDate', idx: 12},
    {title: '수시 보고서', link: '/Html/Student/SchoolReport', idx: 13},
    {title: '수업 계획서', link: '/Html/Student/ClassPlan', idx: 14},
    {title: '멘토 보고서', link: '/Html/Student/MentorReport', idx: 15},
    {title: '만족도 설문조사', link: '/Html/Student/Satisfaction', idx: 16},
    {title: '4주, 8주 보고서', link: '/Html/Student/MonthlyReport', idx: 17},
    {title: '시험전후 상담보고서', link: '/Html/Student/TestReport', idx: 18},
    {title: '수업평가보고서', link: '/Html/Student/EvaluationReport', idx: 19},
    {title: '마무리 수업계획서', link: '/Html/Student/FinishClassPlan', idx: 20},
    {title: '학교명 관리', link: '/Html/Student/SchoolManage', idx: 21},
    {title: '특별회원', link: '/Html/Student/SpeacialMember', idx: 22}
    // {title: '중단우려회원', link: '/Html/Student/SuspensionList', idx: 7},
    // {title: '수시 출석부', link: '/Html/Student/AttendanceSchool', idx: 9},
  ];
  const gnbSubStudentDetail = [
    {title: '학생 상세정보', link: '/Html/Student/Detail/Info', idx: 4},
    {title: '학생  출석부', link: '/Html/Student/Detail/Attendance', idx: 11},
    {title: '입금/환불 내역', link: '/Html/Student/Detail/InOutList', idx: 19},
    {title: '학생 한줄 보고서', link: '/Html/Student/Detail/ShortReport', idx: 6},
    {title: '첫 수업 보고서', link: '/Html/Student/Detail/FirstClassReport', idx: 3},
    {title: '4주 8주 보고서', link: '/Html/Student/Detail/MonthlyReport', idx: 17},
    {title: '수업 평가 보고서', link: '/Html/Student/Detail/EveluationReport', idx: 3},
    {title: '시험 전후 상담보고서', link: '/Html/Student/Detail/TestReport', idx: 18},
    {title: '교재 지급', link: '/Html/Student/Detail/Book', idx: 18}
  ];
  const gnbSubTeacher = [
    {title: '교사목록', link: '/Html/Teacher/List', idx: 1},
    //{ title: "배정관리", link: "/Teacher/AssignManage", idx: 2 },
    {title: '준비중 교사', link: '/Html/Teacher/Preparing', idx: 2},
    {title: '교사 배정지도', link: '/Html/Teacher/Map', idx: 3},
    {title: '배정관리 통계', link: '/Html/Teacher/Statistics', idx: 4},
    {title: '중단/인계/종료 보고', link: '/Html/Teacher/FinishReport', idx: 5},
    {title: '보류/재개', link: '/Html/Teacher/HoldResume', idx: 6},
    {title: '교사별 진행 상태', link: '/Html/Teacher/Progress', idx: 7},
    //{title: '포인트 관리', link: '/Html/Teacher/Point', idx: 7},
    //{title: '인센티브 관리', link: '/Html/Teacher/Incentive', idx: 8},
    {title: '사수 관리', link: '/Html/Teacher/MentorManage', idx: 8},
    {title: '맨토링', link: '/Html/Teacher/Mentoring', idx: 9},
    {title: '실적관리 캠페인', link: '/Html/Teacher/Campaign', idx: 10},
    {title: '계약서 목록', link: '/Html/Teacher/Contract', idx: 11}
    //{title: '멘토 보고서', link: '/Html/Teacher/MentorReport', idx: 5},
    //{title: '무수업 교사 목록', link: '/Html/Teacher/NoClass', idx: 10},
    //{title: '이달의 우수 교사', link: '/Html/Teacher/Good', idx: 11},
    //{title: '주차비 정산', link: '/Html/Teacher/ParkingFee', idx: 12}
  ];
  const gnbSubTeacherDetail = [
    {title: '수업 정보', link: '/Html/Teacher/Detail/ClassInfo', idx: 1},
    {title: '수업 일정', link: '/Html/Teacher/Detail/ClassSchedule', idx: 13},
    {title: '연간실적 통계', link: '/Html/Teacher/Detail/YearStatistics', idx: 14},
    {title: '사수 관리', link: '/Html/Teacher/Detail/MentorManage', idx: 8},
    {title: '교사상세', link: '/Html/Teacher/Detail/Info', idx: 12}
    //{ title: "배정학생 관리", link: "/Teacher/Detail/AssignManage", idx: 2 },
    //{ title: "포인트 관리", link: "/Teacher/Detail/Point", idx: 7 },
    //{ title: "인센티브 명세서", link: "/Teacher/Detail/Incentive", idx: 8 },
  ];
  const gnbSubBook = [
    {title: '출간교재 공지', link: '/Html/Books/Notice', idx: 1},
    //{ title: "교재기획 및 감수", link: "/Books/Marketing", idx: 2 },
    //{ title: "교재 관리 회의록", link: "/Books/MeetingReport", idx: 3 },
    //{ title: "교재 기획서", link: "/Books/PlanningBookReport", idx: 4 },
    {title: '교재 불출 요청하기', link: '/Html/Books/InOutRequest', idx: 5},
    {title: '교재 불출 요청목록', link: '/Html/Books/InOut', idx: 6},
    {title: '교재 재고관리', link: '/Html/Books/Stock', idx: 7},
    {title: '교재 브로셔 제작 발주', link: '/Html/Books/OrderBrochure', idx: 2},
    //{ title: "교재 제작 발주", link: "/Books/RequestMaking", idx: 8 },
    //{title: '교재 단가 계산기', link: '/Html/Books/BookPriceCalculate', idx: 9},
    {title: '총판 발송/반품 내역', link: '/Html/Books/Refund', idx: 10},
    {title: '총판 교재 발송/반품', link: '/Html/Books/RefundBook', idx: 11},
    {title: '홍보책자 재고 관리', link: '/Html/Books/BrochureStock', idx: 12}
    //{ title: "업무 진행비 신청", link: "/Books/RequestFeeList", idx: 12 },
  ];
  const gnbSubData = [
    {title: '자료실 메인', link: '/Html/Data/', idx: 1},
    {title: '자료실 공지사항', link: '/Html/Data/Notice', idx: 2},
    //{title: '화상교재 자료실', link: '/Html/Data/Video', idx: 3},
    //{title: '내신 기술 족보자료', link: '/Html/Data/HistoryExam', idx: 3},
    //{title: '학교별 시험 분석', link: '/Html/Data/AnalysisExam', idx: 4},
    {title: '수업 연구 자료', link: '/Html/Data/ExpectingExam', idx: 5},
    {title: '이지팟 문제유형 목록', link: '/Html/Data/EasyPotList', idx: 6},
    {title: '이지팟 문제은행', link: '/Html/Data/EasyPot', idx: 7}
  ];
  const gnbSubCommunity = [
    {title: '커뮤니티 홈', link: '/Html/Community/Index', idx: 1},
    {title: '공지사항', link: '/Html/Community/Notice', idx: 2},
    //{title: '기획 제안', link: '/Html/Community/Proposal', idx: 3},
    {title: '자유 게시판', link: '/Html/Community/Board', idx: 4},
    //{title: '화상수업 커뮤니티', link: '/Html/Community/VideoClass', idx: 5},
    {title: '이지 포토', link: '/Html/Community/Photo', idx: 6},
    {title: '강의실 예약', link: '/Html/Community/ReservationRoom', idx: 7}
    //{title: '교사 FAQ', link: '/Html/Community/Faq', idx: 8},
    //{title: '회사 긴급 알림', link: '/Html/Community/UrgentNotice', idx: 9}
  ];
  const gnbSubTraining = [
    {title: '면접 평가', link: '/Html/Training/EvaluationInterview', idx: 1},
    {title: '신규 교육 대상자', link: '/Html/Training/LearnerTraining', idx: 2},
    {title: '신규 교사 교육 관리', link: '/Html/Training/TeacherTraining', idx: 3},
    {title: '화상 평가', link: '/Html/Training/VideoEvaluation', idx: 4},
    {title: '교관 관리', link: '/Html/Training/TrainerManage', idx: 5},
    {title: '교사 교육 공고', link: '/Html/Training/Notice', idx: 6},
    {title: '교사 교육 출석부', link: '/Html/Training/Attendance', idx: 7}
    //{title: '연수 일지 등록', link: '/Html/Training/StudyTraining', idx: 5},
    //{title: '사유서 등록', link: '/Html/Training/Reason', idx: 6},
    //{title: '긴급배정 사유서', link: '/Html/Training/UrgentAssignment', idx: 7}
  ];
  const gnbSubPromotion = [
    {title: '시범강의 신청', link: '/Html/Promotion/PRClass', idx: 1},
    {title: '홈페이지 상담신청', link: '/Html/Promotion/Inquiry', idx: 2},
    {title: '전화 수신 현황', link: '/Html/Promotion/CallStatus', idx: 3},
    {title: '인바운드팀', link: '/Html/Promotion/InboundTeam', idx: 4},
    {title: '홍보부', link: '/Html/Promotion/PRList', idx: 5},
    {title: '홍보책자 발송 목록', link: '/Html/Promotion/PRBooklet', idx: 6},
    {title: '홍보책자 재고관리', link: '/Html/Promotion/PRBookletStock', idx: 7},
    {title: '홍보학생 목록', link: '/Html/Promotion/PRStudentList', idx: 8},
    {title: '홍보 이미지', link: '/Html/Promotion/PRMaterials', idx: 9},
    {title: '문자/메일 보내기', link: '/Html/Promotion/SendMail', idx: 10}
    //{title: '시범강의 보고서', link: '/Html/Promotion/PRClassReport', idx: 2},
    //{title: '온라인 무료 상담', link: '/Html/Promotion/OnlineConsulting', idx: 3}
  ];
  const gnbSubAccounting = [
    {title: '월별 입금관리', link: '/Html/Accounting/Month', idx: 1},
    {title: '과목별 입금관리', link: '/Html/Accounting/Subject', idx: 2},
    {
      title: '과목별 미입금 관리',
      link: '/Html/Accounting/SubjectUndeposited',
      idx: 3
    },
    {title: '환불관리', link: '/Html/Accounting/Refund', idx: 4},
    {title: '교사 수업 정산 관리', link: '/Html/Accounting/Calculate', idx: 5},
    {title: '교사 수업 명세서', link: '/Html/Accounting/Salary', idx: 6},
    {title: '인센티브 정산관리', link: '/Html/Accounting/Incentive', idx: 7},
    {
      title: '인센티브 명세서 관리',
      link: '/Html/Accounting/IncentiveCheck',
      idx: 8
    },
    {title: '주차비 정산', link: '/Html/Accounting/ParkingFee', idx: 9},
    {title: '급여 명세서 발송', link: '/Html/Accounting/SendPaystub', idx: 10}
  ];
  const gnbSubManage = [
    {title: '직원관리', link: '/Html/Manage/Employee', idx: 1},
    {title: '회사 문서 양식', link: '/Html/Manage/Papers', idx: 2},
    {title: '증명서 요청', link: '/Html/Manage/CertificationRequest', idx: 3},
    {title: '주간 업무보고', link: '/Html/Manage/WeeklyReport', idx: 5},
    {title: '상품 관리', link: '/Html/Manage/Class', idx: 6},
    {title: '수시 상품 관리', link: '/Html/Manage/GradeClass', idx: 7},
    {title: '할인코드 관리', link: '/Html/Manage/Discount', idx: 8},
    {title: '팝업관리', link: '/Html/Manage/Popup', idx: 9},
    {title: '이달의 생일', link: '/Html/Manage/Birthday', idx: 10},
    {title: '당직 일지', link: '/Html/Manage/DutyLog', idx: 11},
    {title: '홍보키 변경', link: '/Html/Manage/ChangeKey', idx: 12},
    {title: '페이지 접근 설정', link: '/Html/Manage/AccessSetting', idx: 13}
    //{title: '포인트 관리', link: '/Html/Manage/Point', idx: 4},
    //{title: '회의록', link: '/Html/Manage/MeetingReport', idx: 9},
    //{title: '주차비정산', link: '/Html/Manage/ParkingFee', idx: 11}
  ];
  const gnbSubStatistics = [
    {title: '영업실적', link: '/Html/Statistics/Index', idx: 1},
    {title: '담임별 영업실적', link: '/Html/Statistics/Teacher', idx: 2},
    {title: '매출 통계', link: '/Html/Statistics/Sales', idx: 3},
    {title: '교사별 진행 통계', link: '/Html/Statistics/TeacherProgress', idx: 4},
    {title: '교사 입사/퇴사 통계', link: '/Html/Statistics/JoinAndLeave', idx: 4},
    {
      title: '시범강의 성공률',
      link: '/Html/Statistics/DemonstrationLecture',
      idx: 6
    },
    {title: '홍보팀 영업실적', link: '/Html/Statistics/Promotion', idx: 1},
    {title: '홍보전화 통계', link: '/Html/Statistics/PromotionCall', idx: 8},
    {title: '총판 매출 통계', link: '/Html/Statistics/SalesBook', idx: 3}
  ];
  const gnbSubMypage = [
    {title: '마이페이지', link: '/Html/Mypage/Teacher', idx: 1},
    {title: '출석부', link: '/Html/Mypage/Attendance', idx: 2},
    {title: '내 배정관리', link: '/Html/Mypage/AssignManage', idx: 3},
    {title: '받은 메일', link: '/Html/Mypage/ReceiveMail', idx: 4},
    {title: '보낸 메일', link: '/Html/Mypage/SendMail', idx: 5},
    {title: '시수관리', link: '/Html/Mypage/Point', idx: 6},
    {title: '수업 명세서', link: '/Html/Mypage/Salary', idx: 7},
    {title: '인센티브 명세서', link: '/Html/Mypage/Incentive', idx: 8},
    {title: '주차비 정산', link: '/Html/Mypage/ParkingFee', idx: 9},
    {title: '증명서 요청', link: '/Html/Mypage/CertificateRequest', idx: 10},
    {title: '내 정보', link: '/Html/Mypage/MyInfo', idx: 11},
    {title: '담임 - 마이페이지', link: '/Html/Mypage/ClassTeacher', idx: 1},
    {title: '담임 - 입금관리', link: '/Html/Mypage/Payment', idx: 8},
    {title: '담임 - 담당학생 목록', link: '/Html/Mypage/MyStudentList', idx: 12},
    {title: '직원 - 마이페이지', link: '/Html/Mypage/Employee', idx: 1},
    {title: '직원 - 주간 업무보고', link: '/Html/Mypage/WeeklyReport', idx: 13},
    {title: '직원 - 회의록', link: '/Html/Mypage/MeetingReport', idx: 14},
    {title: '직원 - 포인트내역', link: '/Html/Mypage/EmployeePoint', idx: 15},
    {title: '직원 - 내정보', link: '/Html/Mypage/EmployeeInfo', idx: 11}
  ];
  const renderSub = useCallback(() => {
    let arr = [];
    let menuIdx = 0;
    if (pathName === '/Html' || pathName.startsWith('/Html/Member/')) {
      return <></>;
    } else if (pathName.startsWith('/Html/Student/Detail/') && pathName.includes('/Html//Student/Detail')) {
      arr = gnbSubStudentDetail;
      menuIdx = 1;
    } else if (pathName.startsWith('/Html/Student/')) {
      arr = gnbSubStudent;
      menuIdx = 1;
    } else if (pathName.startsWith('/Html/Teacher/Detail/') && pathName.includes('/Html//Teacher/Detail')) {
      arr = gnbSubTeacherDetail;
      menuIdx = 2;
    } else if (pathName.startsWith('/Html/Teacher/')) {
      arr = gnbSubTeacher;
      menuIdx = 2;
    } else if (pathName.startsWith('/Html/Books/')) {
      arr = gnbSubBook;
      menuIdx = 3;
    } else if (pathName.startsWith('/Html/Data/')) {
      arr = gnbSubData;
      menuIdx = 4;
    } else if (pathName.startsWith('/Html/Community/')) {
      arr = gnbSubCommunity;
      menuIdx = 5;
    } else if (pathName.startsWith('/Html/Training/')) {
      arr = gnbSubTraining;
      menuIdx = 6;
    } else if (pathName.startsWith('/Html/Promotion/')) {
      arr = gnbSubPromotion;
      menuIdx = 7;
    } else if (pathName.startsWith('/Html/Accounting/')) {
      arr = gnbSubAccounting;
      menuIdx = 8;
    } else if (pathName.startsWith('/Html/Manage/')) {
      arr = gnbSubManage;
      menuIdx = 9;
    } else if (pathName.startsWith('/Html/Statistics/')) {
      arr = gnbSubStatistics;
      menuIdx = 10;
    } else if (pathName.startsWith('/Html/Mypage/')) {
      arr = gnbSubMypage;
      menuIdx = 12;
    } else {
      arr = gnbSubMain;
      menuIdx = 0;
    }
    return (
      <div className="gnb_sub_wrap">
        <NavLink to="/" className="logo">
          <h1>
            <img src={LogoWhite} className="img" alt="logo" />
          </h1>
        </NavLink>
        <div className="list">
          {arr.map((v, idx) => {
            return (
              <NavLink to={v.link} key={idx} onClick={() => setIsActive(false)} className={`link ${v.idx ? `menu${menuIdx}_` + v.idx : ``}${isActive ? 'active' : ''}`}>
                {v.title}
              </NavLink>
            );
          })}
        </div>
      </div>
    );
  }, [pathName]);

  return (
    // 메인과 External 외부경로가 포함되지 않은 경우
    !pathName.includes('/External') && (
      <header className={`head com_bg ${pathName === '/' || pathName.includes('/Member') ? `isHideGnb` : ``}`}>
        <section className="gnb_wrap">
          <div className="com_center_wrap">
            <NavLink
              to="/"
              onClick={() => {
                setGnbIdx(0);
              }}
              className="logo"
            >
              <h1>
                <img src={Logo} className="img" alt="logo" />
              </h1>
            </NavLink>
            <section className="gnb_list">{renderGnb()}</section>
            <section className="menu_list">
              <NavLink to="/" className="link">
                <img src={IconCall} className="img" alt="call" />
              </NavLink>
              <NavLink to="/" className="link">
                <img src={IconChat} className="img" alt="chat" />
                <span className="icon_notice">25</span>
              </NavLink>
              <NavLink to="/" className="link">
                <img src={IconMail} className="img" alt="mail" />
                <span className="icon_notice">116</span>
              </NavLink>
              <NavLink to="/Mypage/Teacher" className="link">
                <img src={IconMypage} className="img" alt="mypage" />
              </NavLink>
            </section>
          </div>
        </section>
        {renderSub()}
        <div className="side_search_wrap">
          {searchActive ? (
            <>
              <div
                onClick={() => {
                  setSearchActive(false);
                }}
                className="bg_close"
              ></div>
              <div className="search_inner">
                <div className="btn_wrap">
                  <button
                    onClick={() => {
                      setSearchActive(false);
                    }}
                    className="btn_search"
                  >
                    <img src={IconSearch} alt="검색" />
                  </button>
                  <button className="btn_logout">
                    <img src={IconLogout} alt="로그아웃" />
                  </button>
                </div>
                <div className="side_content">
                  <section className="com_board_search">
                    <article className="search full">
                      <input type="search" placeholder="전화번호 & 이름 검색" className="input s type_search"  />
                      <button className="com_btn gray ws s icon_search"  onClick={() => setModalSearch(true)}></button>
                    </article>
                  </section>
                  <div className="com_board_box">
                    <div className="board_item">
                      <div className="tit_row">
                        <p className="cont bold">
                          김교사103 <span className="sub">경기고3/서초구</span>
                        </p>
                        <div className="btn_box">
                          <button className="btn_mail"></button>
                          <button className="btn_message"></button>
                        </div>
                      </div>
                      <div className="info">연락처 : 010-2334-1234</div>
                    </div>
                  </div>
                  <ul className="menu_list">
                    <li className="item">상세정보</li>
                    <li className="item">입금 / 환불 내역</li>
                    <li className="item selected">교재 지급</li>
                    <li className="item">첫 수업 보고서</li>
                    <li className="item">수업평가 보고서</li>
                    <li className="item">학생 출석부</li>
                  </ul>
                  <div className="com_btn_wrap center">
                    <button onClick={() => setModalBookmark(true)} className="com_btn orange s full">
                      + 즐겨찾기 추가
                    </button>
                  </div>
                  <div className="scroll_wrap">
                    <p className="tit">진행중인 수업 : 4</p>
                    <ul className="com_scroll_list pick">
                      {listItems.map((item, index) => (
                        <li key={index} className={`item ${selectedItem === index ? 'selected' : ''}`} onClick={() => setSelectedItem(index)}>
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <div className="btn_wrap">
              <button
                onClick={() => {
                  setSearchActive(true);
                }}
                className="btn_search"
              >
                <img src={IconSearch} alt="검색" />
              </button>
              <button className="btn_logout">
                <img src={IconLogout} alt="로그아웃" />
              </button>
            </div>
          )}
          <PopBookmark open={modalBookmark} close={() => setModalBookmark(false)} />
					<PopSearch open={modalSearch} close={() => setModalSearch(false)} /> {/* 20250218 퍼블 추가&수정 모든 검색버튼 클릭시 노출 */}
        </div>
      </header>
    )
  );
}

export default Header;
